export default "__VITE_ASSET__D5hes$Iv__"